import React,{ Component } from 'react';
import { Link } from 'react-router-dom';
import '../styles/layout.css';
import Room from '../Assets/Room.png';

export default class Header extends Component {
  constructor() {
    super();
    this.state = { isTest: false }
  }
  componentDidMount() {
    fetch(`/test/getenv`)
      .then(res => res.text())
      .then(result => this.setState({ isTest: result === 'stage' }));
  }
  render() {
    return (
      <header>
        <img id="room" src={Room} alt="Logo" width="410" height="217" />
        <div className="header-mobile">
          <div className="header-combined">
            <div className="container">
              <a href="/" className="logo"><img src="logo-neu-mobile.png" alt="GASAG" /></a>
              <Link to="/">Leerstandsmeldung {this.state.isTest ? 'Testsystem' : ''}</Link>
            </div>
          </div>
        </div>
        <div className="header-desktop">
          <div className="header-company" style={{ backgroundImage: 'url(header-neu-muster.png)' }}>
            <div className="container">
              <a href="/" className="logo-small"><img src="logo-neu-110.png" alt="GASAG" /></a>
            </div>
          </div>

          <div className="header-navigation">
            <div className="container">
              <ul className="navbar">

                <li className="logo-container">
                  <a href="/" className="logo">
                    <img src="logo-neu.png" alt="GASAG" />
                  </a>
                </li>
                <li className="title">
                  <Link id="headertitle" to="/">Leerstandsmeldung {this.state.isTest ? 'Testsystem' : ''}</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Header.js